import { useCallback, useState } from 'react'

export type SortDirection = 'asc' | 'desc'

export type SortState<K extends string = string> = { key: K; direction: SortDirection } | null

/** Клик по заголовку: новый ключ → asc, тот же ключ → desc → сброс. */
export const useSort = <K extends string = string>(initial: SortState<K> = null) => {
  const [sort, setSort] = useState<SortState<K>>(initial)

  const toggleSort = useCallback((key: K) => {
    setSort((prev) => {
      if (!prev || prev.key !== key) return { key, direction: 'asc' }
      return prev.direction === 'asc' ? { key, direction: 'desc' } : null
    })
  }, [])

  const getDirection = useCallback(
    (key: K): SortDirection | null => (sort?.key === key ? sort.direction : null),
    [sort],
  )

  return { sort, setSort, toggleSort, getDirection }
}
